import checkout from "./form";

const {
  formField: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    BCTC,
    supportData,
    enterVoiceover,
    auditOpinion,

    chartMaker,
    chiefAccountant,
    certificateNumber,
    accountingService,
    unitHeads,
    dateFounded,
  },
} = checkout;

const initialValues = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [BCTC.name]: false,
  [supportData.name]: false,
  [enterVoiceover.name]: false,
  [auditOpinion.name]: "",

  [chartMaker.name]: "",
  [chiefAccountant.name]: "",
  [certificateNumber.name]: "",
  [accountingService.name]: "",
  [unitHeads.name]: "",
  [dateFounded.name]: "",
};

export default initialValues;
